module.exports = __webpack_public_path__ + "img/PN.a7cc83d2.svg";